<div class="modal-overlay">
  <div class="modal-box">
    <button class="close-btn" (click)="cancel()">×</button>
    <div class="icon-circle">
     <i class="bi bi-trash3" style="color: #e74c3c; font-size: 24px;"></i>
    </div>
    <!-- <p class="msg"> Are you sure you want to delete {{ data.count }} notification(s)?</p> -->
     <p class="msg">{{ displayMessage }}</p>
    <div class="modal-actions">
      <button class="cancel-btn" (click)="cancel()">Cancel</button>
      <button class="confirm-btn" (click)="confirm()">Delete</button>
    </div>
  </div>
</div>

